import { getFullName } from '@zorro/common-utils';
import { ModalMessage } from '@zorro/design-system/v2/ModalMessage';
import {
  useAppRouter,
  useMonolithMutation,
  useMonolithQuery,
  useRoles,
} from '@zorro/web/ui-utils';

type Props = {
  isOpen: boolean;
  employerId: string;
  employeeId: string;
  onClose: () => void;
};

export const DeleteEmployee = ({
  isOpen,
  employerId,
  employeeId,
  onClose,
}: Props) => {
  const { isEmployerAdmin } = useRoles();

  const { navigateToRoute } = useAppRouter();
  const { tryMutate: mutateDeleteEmployee } = useMonolithMutation({
    method: 'employeesControllerDelete',
    successMessage: 'Employee has been deleted successfully',
  });

  const { data: employee, isLoading } = useMonolithQuery({
    method: 'employeesControllerFindOne',
    params: [employeeId],
  });

  if (!employee || isLoading) {
    return null;
  }

  const handleDeleteEmployee = async () => {
    const mutateResult = await mutateDeleteEmployee([employeeId]);
    if (mutateResult.isOk()) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      isEmployerAdmin
        ? navigateToRoute('DON_EMPLOYEES', [{}])
        : navigateToRoute('OPS_EMPLOYERS_EMPLOYEES', [{ employerId }]);
    }
  };

  return (
    <ModalMessage
      isOpen={isOpen}
      onClose={onClose}
      variant="negative"
      title="Delete employee?"
      description={`Are you sure you want to delete ${getFullName(employee)}? This action cannot be undone`}
      primaryLabel="Delete employee"
      onPrimaryAction={handleDeleteEmployee}
      secondaryLabel="Cancel"
      onSecondaryAction={onClose}
    />
  );
};
